export function groupBy<T>(array: T[], property: (x: T) => string): { [key: string]: Array<T> } {
  return array.reduce((memo: { [key: string]: T[] }, x: T) => {
    if (!memo[property(x)]) {
      memo[property(x)] = [];
    }
    memo[property(x)].push(x);
    return memo;
  }, {});
}
